"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
require("dotenv/config");
const bunyan = require("bunyan");
const bunyanFormat = require("bunyan-format");
const BugsnagClient_1 = require("./BugsnagClient");
const ApiErrorSerializers_1 = require("./ApiErrorSerializers");
const ContextualStream_1 = require("./ContextualStream");
exports.log = bunyan.createLogger({
    name: "deliverr",
    level: "info",
    serializers: Object.assign(Object.assign({}, bunyan.stdSerializers), ApiErrorSerializers_1.apiErrorSerializers),
    streams: [],
});
function bindConsoleToLogger(logger) {
    console.log = console.info = logger.info.bind(logger);
    console.error = logger.error.bind(logger);
    console.warn = logger.warn.bind(logger);
    console.trace = logger.trace.bind(logger);
}
if (process.env.ENABLE_TEST_LOGS && process.env.ENABLE_TEST_LOGS.trim().toLowerCase() !== "false") {
    const testLogLevelString = process.env.TEST_LOG_LEVEL;
    const testLogLevel = bunyan.levelFromName[testLogLevelString];
    exports.log.addStream({
        level: (testLogLevel !== null && testLogLevel !== void 0 ? testLogLevel : bunyan.levelFromName["debug"]),
        stream: bunyanFormat({
            outputMode: "short",
            color: true,
            colorFromLevel: {
                10: "blue",
                20: "cyan",
                30: "green",
                40: "yellow",
                50: "red",
                60: "inverse",
            },
        }),
    });
    bindConsoleToLogger(exports.log);
}
if (process.env.ENABLE_RAW_LOGS && process.env.ENABLE_RAW_LOGS.trim().toLowerCase() !== "false") {
    const rawLogLevelString = process.env.RAW_LOG_LEVEL;
    const rawLogLevel = bunyan.levelFromName[rawLogLevelString];
    exports.log.addStream({
        level: (rawLogLevel !== null && rawLogLevel !== void 0 ? rawLogLevel : bunyan.levelFromName["info"]),
        type: "raw",
        stream: new ContextualStream_1.ContextualStream(),
    });
    bindConsoleToLogger(exports.log);
}
if (BugsnagClient_1.bugsnag) {
    exports.log.addStream({
        name: "bugsnag",
        stream: new BugsnagClient_1.BugsnagStream(),
        level: "error",
        type: "raw",
    });
}
//# sourceMappingURL=Logger.js.map